import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP4UnderUtilizedOvw202601: FaireAdPerformancePeriodEntity = {
  token: "perf_p4_under_utilized_ovw_202601",
  type: "adPerformancePeriod",
  scope: "OVERVIEW",
  periodType: "RECEIPT",
  startDate: "2026-01-01",
  endDate: "2026-01-31",
  impressions: 9671,
  clicks: 136,
  adsSpendDollars: 636,
  budgetDollars: 15000,
  salesDollars: 2129,
  bestEstimateRoas: 3.35,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.04,
  newCustomersAcquired: 2,
  reorderConversions: 3,
  dataAvailableAtDate: "2026-02-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
